<template>
  <a-modal
    :footer="false"
    :open="isOpen"
    :title="`DO YOU WANT TO DELETE THIS DEPOT?`"
    @cancel="close"
  >
    <div class="gap-10 my-10">
      <div class="mb-3">
        <label-text :labelText="'Enter Password'" />
        <input
          class="w-full border p-2 rounded-lg"
          placeholder="Enter password"
          v-model="password"
        />
      </div>
      <SubmitButton
        @click="deleteDepot"
        :val="'Delete Depot'"
        :loading="this.loading"
      />
      <!-- <SubmitButton
        @click="close"
        class="bg-red-500"
        :val="'No'"
        :loading="false"
      /> -->
    </div>
  </a-modal>
</template>

<script>
//services
import depotService from "@/services/depot-service";

//libraries
import { useToast } from "vue-toastification";

//components
import SubmitButton from "@/components/UI/Inputs/FormSubmitInput.vue";
import LabelText from "../../../UI/Text/LabelText.vue";

export default {
  name: "DeleteDepotModal",
  props: ["isOpen", "close", "depotId"],
  components: {
    SubmitButton,
    LabelText,
  },
  data() {
    return {
      loading: false,
      toast: useToast(),
      password: "",
    };
  },
  methods: {
    //requests
    async deleteDepot() {
      this.loading = true;
      console.log("Got in hereeee");
      if (!this.password) {
        this.toast.error("Password is required", { timeout: 3000 });
        this.loading = false;
        return;
      }
      try {
        const payload = { depotId: this.depotId, password: this.password };
        const result = await depotService.deleteDepot(payload);
        this.toast.success("Depot Deleted Successfully");
        this.$router.push("/depot");
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
